import { createNotification as createNotificationServer } from './secureFunctions';

export const createNotification = async (
  userId: string,
  type: 'like' | 'comment' | 'follow' | 'mention',
  fromUserId: string,
  fromUserName: string,
  fromUserPhoto: string,
  message: string,
  contentId?: string,
  contentType?: 'post' | 'pulse' | 'testimony',
  extra?: Partial<{ snippet: string }>
) => {
  try {
    await createNotificationServer({
      userId,
      type,
      fromUserName,
      fromUserPhoto,
      message,
      contentId: contentId || null,
      contentType: contentType || null,
      snippet: extra?.snippet,
    });
  } catch (error) {
    console.error('Error creating notification:', error);
  }
};
